import styled from '@emotion/styled';

export default function TextSkeleton({ ...props }) {
  return <Container {...props} />;
}

const Container = styled.div`
  width: 100%;
  height: 20px;
  border-radius: 24px;
  background-color: ${(props) => props.theme.backgroundColor.bg_dark_2};
`;
